var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "w-full" }, [
    !_vm.settingsOpened
      ? _c(
          "div",
          {
            staticClass: "flex flex-col w-full",
            class: { "cursor-wait": _vm.fetchLoading },
            style: { minHeight: "calc(100vh - 3.75rem - 3rem - 4px)" }
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "sticky top-0 z-10 h-40 px-6 pt-3 border-b bg-pure-white border-slate-400"
              },
              [
                _c(
                  "div",
                  { staticClass: "flex items-center justify-between" },
                  [
                    _c("BlTextSubtitle2", {
                      staticClass: "text-slate-700",
                      attrs: { text: "View target comments and results" }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex items-center gap-2" },
                      [
                        _c("BlInputButton", {
                          attrs: {
                            label: "Settings",
                            type: "outlined",
                            dense: ""
                          },
                          on: {
                            clicked: function($event) {
                              _vm.settingsOpened = true
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("BlIcon", {
                          staticClass: "w-6 h-6",
                          attrs: { icon: "close", clickable: "" },
                          on: {
                            clicked: function($event) {
                              return _vm.$emit("close")
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mt-1" },
                  [
                    _c("BlTextBody2", {
                      attrs: {
                        text:
                          "View all comments and results recorded for targets during sessions."
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "w-full mt-4", style: { maxWidth: "100%" } },
                  [
                    _c("BlSelectBox", {
                      attrs: {
                        placeholder: "Select a target",
                        options: _vm.targets.map(function(i) {
                          return { value: i.id, label: i.name }
                        })
                      },
                      on: {
                        change: function($event) {
                          _vm.targetId = $event
                        }
                      },
                      model: {
                        value: _vm.targetId,
                        callback: function($$v) {
                          _vm.targetId = $$v
                        },
                        expression: "targetId"
                      }
                    })
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "flex flex-col gap-4 px-6 overflow-x-auto max-w-132 scrollbar-lg"
              },
              [
                _vm.fetchLoading
                  ? _c("div", { staticClass: "py-4" }, [_vm._m(0)])
                  : !_vm.targetId
                  ? _c("div", { staticClass: "py-4" }, [
                      _c(
                        "div",
                        { staticClass: "flex flex-col py-32 text-center" },
                        [
                          _c("BlTextBody2", {
                            attrs: { text: "No targets selected yet." }
                          }),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            attrs: {
                              text:
                                "Please choose a target to view its comments and results."
                            }
                          })
                        ],
                        1
                      )
                    ])
                  : !_vm.entries.length
                  ? _c("div", { staticClass: "py-4" }, [
                      _c(
                        "div",
                        { staticClass: "py-32 text-center" },
                        [
                          _c("BlTextBody2", {
                            attrs: { text: "Comments(s) not found." }
                          })
                        ],
                        1
                      )
                    ])
                  : _c("div", { staticClass: "flex flex-col gap-2" }, [
                      _c(
                        "div",
                        {
                          staticClass: "py-2 bg-pure-white",
                          style: { zIndex: 1 }
                        },
                        [
                          _vm.target.type === "Target::Prompting" &&
                          _vm.useResult
                            ? _c("div", { staticClass: "flex mb-4" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "flex px-1 py-1 bg-slate-400",
                                    style: {
                                      borderRadius: "8px",
                                      height: "2.375rem"
                                    }
                                  },
                                  _vm._l(_vm.progressByOptions, function(opt) {
                                    return _c(
                                      "div",
                                      {
                                        key: opt.value,
                                        staticClass:
                                          "flex items-center justify-center flex-shrink-0 h-full transition-all duration-300 rounded cursor-pointer w-30",
                                        class: [
                                          _vm.progressBy === opt.value
                                            ? "bg-pure-white"
                                            : "bg-slate-400"
                                        ],
                                        on: {
                                          click: function($event) {
                                            _vm.progressBy = opt.value
                                          }
                                        }
                                      },
                                      [
                                        _c("BlTextSubtitle3", {
                                          attrs: { text: opt.label }
                                        })
                                      ],
                                      1
                                    )
                                  }),
                                  0
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "flex items-center" }, [
                            _c(
                              "div",
                              { staticClass: "flex-shrink-0 w-25" },
                              [
                                _c("BlTextBody2", {
                                  staticClass: "text-slate-700",
                                  attrs: { text: "Date" }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.useResult
                              ? _c(
                                  "div",
                                  { staticClass: "flex items-center" },
                                  [
                                    _vm.target.type === "Target::Duration"
                                      ? _c(
                                          "div",
                                          [
                                            _c("BlTextBody2", {
                                              staticClass: "text-slate-700",
                                              attrs: { text: "Recorded time" }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm.target.type === "Target::Prompting"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex items-center gap-2"
                                          },
                                          [
                                            _vm.progressBy === "final_score"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex-shrink-0 w-20"
                                                  },
                                                  [
                                                    _c("BlTextBody2", {
                                                      staticClass:
                                                        "text-slate-700",
                                                      attrs: {
                                                        text: "Final score"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              : _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex items-center gap-2"
                                                  },
                                                  _vm._l(
                                                    _vm.target.prompts,
                                                    function(prompt) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: prompt.id,
                                                          staticClass:
                                                            "flex justify-center flex-shrink-0",
                                                          class: {
                                                            "w-7.5":
                                                              _vm.currentProgressBy ===
                                                              "score",
                                                            "w-10":
                                                              _vm.currentProgressBy ===
                                                              "percentage"
                                                          }
                                                        },
                                                        [
                                                          _c("BlTextBody2", {
                                                            staticClass:
                                                              "text-slate-700",
                                                            attrs: {
                                                              text:
                                                                prompt.abbreviation
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                          ]
                                        )
                                      : _vm.target.type === "Target::Sbt"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex items-center gap-2"
                                          },
                                          [
                                            _vm._l(
                                              _vm.target.target_tasks,
                                              function(task) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key:
                                                      "task-" +
                                                      task.id +
                                                      task.id,
                                                    staticClass:
                                                      "flex justify-center flex-shrink-0 w-14"
                                                  },
                                                  [
                                                    _c("BlTextBody2", {
                                                      staticClass:
                                                        "h-4.5 text-slate-700",
                                                      attrs: { text: task.code }
                                                    })
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.target
                                                .target_problem_behaviors,
                                              function(pb) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: "pb-" + pb.id + pb.id,
                                                    staticClass:
                                                      "flex justify-center flex-shrink-0 w-14"
                                                  },
                                                  [
                                                    _c("BlTextBody2", {
                                                      staticClass:
                                                        "text-slate-700 h-4.5",
                                                      attrs: { text: pb.code }
                                                    })
                                                  ],
                                                  1
                                                )
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      : _c(
                                          "div",
                                          { staticClass: "w-20" },
                                          [
                                            _vm.target.type ===
                                            "Target::Frequency"
                                              ? _c("BlTextBody2", {
                                                  staticClass: "text-slate-700",
                                                  attrs: { text: "Frequency" }
                                                })
                                              : _vm.target.type !==
                                                "Target::Sbt"
                                              ? _c("BlTextBody2", {
                                                  staticClass: "text-slate-700",
                                                  attrs: { text: "Score" }
                                                })
                                              : _vm._e()
                                          ],
                                          1
                                        ),
                                    _vm._v(" "),
                                    _vm.target.type === "Target::Pir"
                                      ? _c(
                                          "div",
                                          [
                                            _c("BlTextBody2", {
                                              staticClass: "text-slate-700",
                                              attrs: { text: "Percentage" }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                )
                              : _c(
                                  "div",
                                  [
                                    _c("BlTextBody2", {
                                      staticClass: "text-slate-700",
                                      attrs: { text: "Comment" }
                                    })
                                  ],
                                  1
                                )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex flex-col gap-2" },
                        _vm._l(_vm.filteredEntries, function(entry) {
                          return _c("div", { key: entry.id }, [
                            entry.type === "Entry::PhaseLine"
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "flex items-center gap-2 py-2"
                                  },
                                  [
                                    _c("div", {
                                      staticClass:
                                        "w-full bg-slate-300 h-0.5 rounded-full"
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex items-center flex-shrink-0 gap-2"
                                      },
                                      [
                                        entry.target_type !==
                                        "Target::Prompting"
                                          ? _c("div", {
                                              staticClass:
                                                "flex-shrink-0 w-5 h-5 rounded-full",
                                              style: {
                                                backgroundColor:
                                                  _vm.phaseLineColors[
                                                    entry.line_color
                                                  ]
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("BlTextSubtitle3", {
                                          attrs: { text: entry.line_label }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass:
                                        "w-full bg-slate-300 h-0.5 rounded-full"
                                    })
                                  ]
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex py-2 border-b border-slate-400"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "flex-shrink-0 w-25" },
                                      [
                                        _c("BlTextBody2", {
                                          attrs: {
                                            text: _vm.displayDate({
                                              date: entry.recorded_at
                                            })
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "flex flex-col gap-2" },
                                      [
                                        _vm.useResult
                                          ? _c("div", { staticClass: "flex" }, [
                                              entry.type === "Entry::Duration"
                                                ? _c(
                                                    "div",
                                                    [
                                                      _c("BlTextBody2", {
                                                        attrs: {
                                                          text:
                                                            entry.recorded_time
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                : entry.type ===
                                                  "Entry::Prompting"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex items-center gap-2"
                                                    },
                                                    [
                                                      _vm.progressBy ===
                                                      "final_score"
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "flex justify-center flex-shrink-0 w-20"
                                                            },
                                                            [
                                                              _c(
                                                                "BlTextBody2",
                                                                {
                                                                  attrs: {
                                                                    text:
                                                                      entry.score +
                                                                      "%"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "flex items-center gap-2"
                                                            },
                                                            _vm._l(
                                                              _vm.target
                                                                .prompts,
                                                              function(prompt) {
                                                                return _c(
                                                                  "div",
                                                                  {
                                                                    key:
                                                                      prompt.id,
                                                                    staticClass:
                                                                      "h-7.5 flex-shrink-0 flex items-center justify-center",
                                                                    class: {
                                                                      "w-7.5":
                                                                        _vm.currentProgressBy ===
                                                                        "score",
                                                                      "w-10":
                                                                        _vm.currentProgressBy ===
                                                                        "percentage"
                                                                    },
                                                                    style: {
                                                                      backgroundColor: entry
                                                                        .scores[
                                                                        prompt
                                                                          .id
                                                                      ][
                                                                        _vm
                                                                          .currentProgressBy
                                                                      ]
                                                                        ? _vm
                                                                            .promptColors[
                                                                            prompt
                                                                              .color
                                                                          ]
                                                                            .primaryColor
                                                                        : "transparent"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "BlTextBody2",
                                                                      {
                                                                        style: {
                                                                          color: entry
                                                                            .scores[
                                                                            prompt
                                                                              .id
                                                                          ][
                                                                            _vm
                                                                              .currentProgressBy
                                                                          ]
                                                                            ? _vm
                                                                                .promptColors[
                                                                                prompt
                                                                                  .color
                                                                              ]
                                                                                .textColor
                                                                            : ""
                                                                        },
                                                                        attrs: {
                                                                          text:
                                                                            "" +
                                                                            entry
                                                                              .scores[
                                                                              prompt
                                                                                .id
                                                                            ][
                                                                              _vm
                                                                                .currentProgressBy
                                                                            ] +
                                                                            (_vm.currentProgressBy ===
                                                                            "percentage"
                                                                              ? "%"
                                                                              : "")
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          )
                                                    ]
                                                  )
                                                : entry.type === "Entry::Sbt"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex items-center gap-2"
                                                    },
                                                    [
                                                      _vm._l(
                                                        _vm.target.target_tasks,
                                                        function(task) {
                                                          return _c(
                                                            "div",
                                                            {
                                                              key:
                                                                "task-" +
                                                                task.id,
                                                              staticClass:
                                                                "w-14 h-7.5 flex-shrink-0 flex items-center justify-center",
                                                              style: {
                                                                backgroundColor: _vm.getAverageScore(
                                                                  entry,
                                                                  task.id
                                                                )
                                                                  ? task.color
                                                                  : "transparent"
                                                              },
                                                              attrs: {
                                                                id: task.id
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "BlTextBody2",
                                                                {
                                                                  style: {
                                                                    color: _vm.getAverageScore(
                                                                      entry,
                                                                      task.id
                                                                    )
                                                                      ? "#FFFFFF"
                                                                      : "#A0A0A0"
                                                                  },
                                                                  attrs: {
                                                                    text: _vm.getAverageScore(
                                                                      entry,
                                                                      task.id
                                                                    )
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                      _vm._v(" "),
                                                      _vm._l(
                                                        _vm.target
                                                          .target_problem_behaviors,
                                                        function(pb) {
                                                          return _c(
                                                            "div",
                                                            {
                                                              key:
                                                                "pb-" + pb.id,
                                                              staticClass:
                                                                "flex justify-center flex-shrink-0 w-14",
                                                              attrs: {
                                                                id: pb.id
                                                              }
                                                            },
                                                            [
                                                              _vm.getRecordProblemBehaviors(
                                                                entry,
                                                                pb.id
                                                              ) !== 0
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "flex items-center justify-center flex-shrink-0 w-12 h-8 cursor-pointer",
                                                                      style: {
                                                                        backgroundColor:
                                                                          pb.color
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "BlTextBody2",
                                                                        {
                                                                          style: {
                                                                            color:
                                                                              "#FFFFFF"
                                                                          },
                                                                          attrs: {
                                                                            text: _vm.getRecordProblemBehaviors(
                                                                              entry,
                                                                              pb.id
                                                                            )
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          )
                                                        }
                                                      )
                                                    ],
                                                    2
                                                  )
                                                : _c(
                                                    "div",
                                                    { staticClass: "w-20" },
                                                    [
                                                      _vm.target.type ===
                                                      "Target::Frequency"
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "w-7.5 h-7.5 flex-shrink-0 flex items-center justify-center",
                                                              class: {
                                                                "bg-light-purple-300":
                                                                  entry.score
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "BlTextBody2",
                                                                {
                                                                  class: {
                                                                    "text-pure-white":
                                                                      entry.score
                                                                  },
                                                                  attrs: {
                                                                    text:
                                                                      entry.score
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _c("BlTextBody2", {
                                                            attrs: {
                                                              text: entry.score
                                                            }
                                                          })
                                                    ],
                                                    1
                                                  ),
                                              _vm._v(" "),
                                              entry.type === "Entry::Pir"
                                                ? _c(
                                                    "div",
                                                    [
                                                      _c("BlTextBody2", {
                                                        attrs: {
                                                          text:
                                                            entry.percentage +
                                                            "%"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.useComment
                                          ? _c(
                                              "div",
                                              { staticClass: "w-full" },
                                              [
                                                _c("BlTextBody2", {
                                                  attrs: {
                                                    text: entry.comment || "-"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]
                                )
                          ])
                        }),
                        0
                      )
                    ])
              ]
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.settingsOpened
      ? _c("div", { staticClass: "flex flex-col" }, [
          _c(
            "div",
            {
              staticClass:
                "flex items-center justify-between px-6 py-4 border-b border-slate-400"
            },
            [
              _c("BlTextSubtitle2", {
                staticClass: "text-slate-700",
                attrs: { text: "Settings" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "flex flex-col gap-3 px-6 py-4" }, [
            _c(
              "div",
              { staticClass: "flex flex-col gap-1" },
              [
                _c("BlTextSubtitle3", { attrs: { text: "Sort by" } }),
                _vm._v(" "),
                _vm._l(_vm.sortByOptions, function(opt) {
                  return _c(
                    "div",
                    {
                      key: opt.value,
                      staticClass: "flex gap-2 pl-6 cursor-pointer",
                      on: {
                        click: function($event) {
                          _vm.sortByInput = opt.value
                        }
                      }
                    },
                    [
                      _c("BlInputRadio", {
                        attrs: {
                          checked: _vm.sortByInput === opt.value,
                          name: "select_sort_by"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex flex-col gap-1" },
                        [
                          _c("BlTextBody2", { attrs: { text: opt.label } }),
                          _vm._v(" "),
                          opt.description
                            ? _c("BlTextBody2", {
                                staticClass:
                                  "whitespace-pre-line text-slate-700",
                                attrs: { text: opt.description }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                })
              ],
              2
            ),
            _vm._v(" "),
            _c("div", {
              staticClass: "h-0.5 w-full flex-shrink-0 bg-slate-200 rounded"
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex flex-col gap-1" },
              [
                _c("BlTextSubtitle3", { attrs: { text: "Session display" } }),
                _vm._v(" "),
                _vm._l(_vm.sessionDisplayOptions, function(opt) {
                  return _c(
                    "div",
                    {
                      key: opt.value,
                      staticClass: "flex gap-2 pl-6 cursor-pointer",
                      on: {
                        click: function($event) {
                          _vm.sessionDisplayInput = opt.value
                        }
                      }
                    },
                    [
                      _c("BlInputRadio", {
                        attrs: {
                          checked: _vm.sessionDisplayInput === opt.value,
                          name: "select_session_display"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex flex-col gap-1" },
                        [
                          _c("BlTextBody2", { attrs: { text: opt.label } }),
                          _vm._v(" "),
                          opt.description
                            ? _c("BlTextBody2", {
                                staticClass:
                                  "whitespace-pre-line text-slate-700",
                                attrs: { text: opt.description }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                })
              ],
              2
            ),
            _vm._v(" "),
            _c("div", {
              staticClass: "h-0.5 w-full flex-shrink-0 bg-slate-200 rounded"
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex flex-col gap-1" },
              [
                _c("BlTextSubtitle3", { attrs: { text: "View options" } }),
                _vm._v(" "),
                _vm._l(_vm.viewOptionOptions, function(opt) {
                  return _c(
                    "div",
                    {
                      key: opt.value,
                      staticClass: "flex gap-2 pl-6 cursor-pointer",
                      on: {
                        click: function($event) {
                          _vm.viewOptionInput = opt.value
                        }
                      }
                    },
                    [
                      _c("BlInputRadio", {
                        attrs: {
                          checked: _vm.viewOptionInput === opt.value,
                          name: "select_view_option"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex flex-col gap-1" },
                        [
                          _c("BlTextBody2", { attrs: { text: opt.label } }),
                          _vm._v(" "),
                          opt.description
                            ? _c("BlTextBody2", {
                                staticClass:
                                  "whitespace-pre-line text-slate-700",
                                attrs: { text: opt.description }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                })
              ],
              2
            ),
            _vm._v(" "),
            _c("div", {
              staticClass: "h-0.5 w-full flex-shrink-0 bg-slate-200 rounded"
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "grid items-center grid-cols-2 gap-4 px-6 py-4" },
            [
              _c("BlInputButton", {
                attrs: { label: "Cancel", type: "plain" },
                on: {
                  clicked: function($event) {
                    _vm.settingsOpened = false
                  }
                }
              }),
              _vm._v(" "),
              _c("BlInputButton", {
                attrs: { label: "Update" },
                on: { clicked: _vm.onSaveSettings }
              })
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "grid py-32 place-items-center" }, [
      _c("div", { staticClass: "blum-loader" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-361a816a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-361a816a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/helper/ViewComments.vue
// module id = null
// module chunks = 